import('~/booklet.js')
